import React from 'react'
import './stepper.scss'

interface StepperProps {
    steps: Array<{ title: string, value: number, icon?: any }>;
    currentStep: number;
}

const Stepper = ({ steps, currentStep }: StepperProps) => {

    let currentStepIdx = steps.findIndex(item => item.value == currentStep)
    return (
        <div className="a-stepper-container">
            <div className="a-stepper-container__box">
                {
                    steps.map((step, idx) => (
                        <React.Fragment key={`${step.title}-${idx}`}>
                            <div className={`a-stepper-container__box__step ${currentStepIdx === idx ? 'a-stepper-container__box__step--active' : ''} 
                            ${idx < currentStepIdx ? 'a-stepper-container__box__step--checked' : ''}`}>
                                {idx < currentStepIdx ? <span>&#10003;</span> : <h3>{idx + 1}</h3>}
                                {currentStepIdx === idx && <p>{step.title}</p>}
                            </div>
                            {idx < steps.length - 1 && <p className={`a-stepper-container__box__line ${idx < currentStepIdx ? 'a-stepper-container__box__line--active' : ''}`}></p>}
                        </React.Fragment>
                    ))
                }
            </div>
        </div>
    )
}

export default Stepper